import React, { useMemo } from 'react';
import { TeamInLeague, DevelopmentHistoryRecord, Player } from '../../../domain/entities';
import { View } from '../../../App';

interface PlayerDevelopmentHistoryRecord extends DevelopmentHistoryRecord {
    playerId: number;
    playerName: string;
}

interface TrainingHistoryPanelProps {
    team: TeamInLeague;
    pushView: (view: View) => void;
}

const getIconForType = (type: 'skill' | 'attribute' | 'physical') => {
    switch (type) {
        case 'skill': return '⭐';
        case 'attribute': return '📈';
        case 'physical': return '💪';
        default: return '➡️';
    }
};

export const TrainingHistoryPanel: React.FC<TrainingHistoryPanelProps> = ({ team, pushView }) => {
    const allHistory = useMemo(() => {
        const history: PlayerDevelopmentHistoryRecord[] = [];
        team.squad.forEach(player => {
            (player.developmentHistory || []).forEach(record => {
                history.push({ ...record, playerId: player.id, playerName: player.name });
            });
        });
        return history.sort((a, b) => (b.season * 100 + b.week) - (a.season * 100 + a.week));
    }, [team.squad]);

    return (
        <div className="panel">
            <div className="panel-header">Team Development History</div>
            <div className="panel-content">
                <p>A log of all skill and attribute improvements across your squad. Newest entries are at the top.</p>
                <div className="table-wrapper" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Player</th>
                                <th>S/W</th>
                                <th>Improvement</th>
                                <th style={{ textAlign: 'center' }}>Change</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allHistory.length === 0 ? (
                                <tr><td colSpan={4} style={{ textAlign: 'center' }}>No development history recorded yet.</td></tr>
                            ) : (
                                allHistory.map((entry, index) => (
                                    <tr key={index}>
                                        <td>
                                            <button className="link-style" onClick={() => pushView({ type: 'playerDetail', title: `Player: ${entry.playerName}`, playerId: entry.playerId })}>
                                                {entry.playerName}
                                            </button>
                                        </td>
                                        <td>S{entry.season} W{entry.week}</td>
                                        <td>{getIconForType(entry.type)} {entry.description}</td>
                                        <td style={{ textAlign: 'center' }} className="positive">+{entry.change}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
